import { useState, useEffect } from "react";
import { Textarea } from "../ui/textarea";
import { Button } from "../ui/button";
import { Pencil } from "lucide-react";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  GetClaimDetailApi,
  UpdateClaimApi,
} from "../../features/Claims/ClaimsAPI";

function ClaimPlanDetails(props) {
  const dispatch = useDispatch();
  const { claimId: urlClaimId } = useParams();
  const [isEditing, setIsEditing] = useState(false);
  const [claimDetails, setClaimDetails] = useState(null);
  const [tempDescription, setTempDescription] = useState("");

  const handleCancel = () => {
    setTempDescription(claimDetails?.description || "");
    setIsEditing(false);
  };

  const handleUpdate = async () => {
    if (!claimDetails?.claimID) return;

    const payload = {
      claimId: claimDetails.claimID,
      description: tempDescription,
      issueType: claimDetails.issueType,
      status: claimDetails.status || "Draft",
      claimAmount: claimDetails.claimAmount || 0,
    };

    const result = await dispatch(UpdateClaimApi(payload));
    if (result.success) {
      setClaimDetails((prev) => ({
        ...prev,
        description: tempDescription,
      }));
      setIsEditing(false);
    } else {
      console.error("Failed to update claim:", result.error);
    }
  };

  useEffect(() => {
    if (urlClaimId) {
      const fetchClaimDetails = async () => {
        try {
          const response = await GetClaimDetailApi(urlClaimId.toString());
          if (response.success && response.payload) {
            setClaimDetails(response.payload);
            setTempDescription(response.payload.description || "");
          } else {
            console.error("Failed to verify plan from URL:", response.error);
          }
        } catch (error) {
          console.error("Error verifying plan from URL:", error);
        }
      };
      fetchClaimDetails();
    }
  }, [urlClaimId]);

  return (
    <>
      <div className="grid grid-cols-3 gap-2 text-sm text-slate-700">
        {/* <div>
          <p className="text-slate-500">Plan ID:</p>
          <p className="font-medium">{claimDetails?.plan?.businessPlanID}</p>
        </div>
        <div>
          <p className="text-slate-500">Product Name:</p>
          <p className="font-medium">{claimDetails?.plan?.productName}</p>
        </div>
        <div>
          <p className="text-slate-500">Customer:</p>
          <p className="font-medium">{claimDetails?.customer?.fullName}</p>
        </div> */}
        <div>
          <p className="text-slate-500">Created On:</p>
          <p className="font-medium">
            {claimDetails?.createdDate
              ? new Date(claimDetails.createdDate).toLocaleDateString("en-IN", {
                  day: "2-digit",
                  month: "2-digit",
                  year: "numeric",
                })
              : ""}
          </p>
        </div>
        <div>
          <p className="text-slate-500">Issue Type:</p>
          <p className="font-medium">{claimDetails?.issueType}</p>
        </div>
        <div>
          <p className="text-slate-500">Status:</p>
          <p className="font-medium">{claimDetails?.plan?.planStatus}</p>
        </div>
      </div>

      <div className="grid grid-cols-1 mt-2 text-sm text-slate-700">
        <div className="flex items-start justify-between">
          <div className="w-full">
            <p className="text-slate-500 text-sm mb-1">
              Issue Description:{" "}
              {!isEditing && props.currentStep !== "evidence-upload" && (
                <button
                  className="text-blue-500 hover:text-blue-700"
                  onClick={() => setIsEditing(true)}
                  aria-label="Edit Description"
                >
                  <Pencil size={16} />
                </button>
              )}
            </p>
            {!isEditing ? (
              <p className="text-slate-800 text-sm whitespace-pre-line">
                {claimDetails?.description}
              </p>
            ) : (
              <Textarea
                className="min-h-[150px] w-full"
                value={tempDescription}
                onChange={(e) => setTempDescription(e.target.value)}
              />
            )}
          </div>
        </div>

        {isEditing && (
          <div className="flex gap-3 mt-3">
            <Button variant="outline" onClick={handleCancel}>
              Cancel
            </Button>
            <Button onClick={handleUpdate}>Update</Button>
          </div>
        )}
      </div>
    </>
  );
}
export default ClaimPlanDetails;
